import styled from 'styled-components';
import { DESKTOP_MIN_BREAK } from '#/shared/constants';

export const DetailViewHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: ${DESKTOP_MIN_BREAK};
  background-color: ${props => props.theme.inverseBackgroundColor2};
  color: ${props => props.theme.secondaryBackgroundColor};
  padding: 8px;
  border-radius: 0;
`;

export const DetailViewHeaderTop = styled.div`
  width: 100%;
  display: flex;
`;

export const DetailViewHeaderIconColumn = styled.div`
  position: relative;
  flex: 0 1 75px;
  min-height: 75px;
`;

export const DetailViewNameColumn = styled.div`
  padding: 5px;
  flex: 1 1 auto;
`;

export const DetailViewHeaderName = styled.div`
  font-size: 1.3em;
  line-height: 1.15;
  margin-bottom: 5px;
`;

export const DetailViewHeaderActionRow = styled.div`
  font-size: 1.1em;
`;
